/**
 * App-level LanguageToggle wired to i18n context.
 */
import { LanguageToggle as LanguageToggleUi } from "../../ui/components/LanguageToggle";
import type { LanguageToggleProps } from "../../ui/components/LanguageToggle";
import { useI18n } from "../lib/i18n";

export type { LanguageToggleProps };

export function LanguageToggle({
  placement = "fixed",
}: {
  placement?: LanguageToggleProps["placement"];
}) {
  const { currentLanguage, openLanguagePicker } = useI18n();

  return (
    <LanguageToggleUi
      placement={placement}
      flagUrl={currentLanguage?.flagUrl}
      languageName={currentLanguage?.name}
      onClick={openLanguagePicker}
    />
  );
}
